import React from 'react';
import { useSettingsOAuthCallback } from './useSettingsOAuthCallback';
import SettingsProcessingStatus from './components/SettingsProcessingStatus';
import SettingsSuccessStatus from './components/SettingsSuccessStatus';
import SettingsErrorStatus from './components/SettingsErrorStatus';

export default function OAuthCallbackPage() {
  const {
    status,
    errorMessage,
    provider,
    handleRetry,
    handleReturnToSettings
  } = useSettingsOAuthCallback();

  const renderStatus = () => {
    switch (status) {
      case 'processing':
        return <SettingsProcessingStatus provider={provider} />;
      case 'success':
        return <SettingsSuccessStatus provider={provider} />;
      case 'error':
        return (
          <SettingsErrorStatus
            message={errorMessage}
            provider={provider}
            onRetry={handleRetry}
            onReturnToSettings={handleReturnToSettings}
          />
        );
      default:
        return <SettingsProcessingStatus provider={provider} />;
    }
  };

  return (
    <div style={{
      padding: '2rem',
      textAlign: 'center',
      maxWidth: '500px',
      margin: '0 auto',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      {renderStatus()}
    </div>
  );
}
